module.exports = __webpack_public_path__ + "img/275972e3810c6a9129f4c3459ee21a53.b2c0fb95.jpg";